import { Table } from "../../../../../components/Table";
import styles from "./RelatorioFreguesia.module.css";
import "./Print.css"

const formasDePagamento = [
  {
    tipo: "1-Dinheiro",
  },
  {
    tipo: "2-Vale",
  },
  {
    tipo: "3-Produtos",
  },
  {
    tipo: "4-Dinheiro/Produto",
  },
  {
    tipo: "5-Pix/Produto",
  },
  {
    tipo: "6-Vale/Produto",
  },
  {
    tipo: "7-Doação",
  },
  {
    tipo: "8-Dinheiro/Vale",
  },
  {
    tipo: "9-Pix",
  },
  {
    tipo: "10-Pix/Dinheiro",
  },
];

const columns = [
  {
    column: "Código",
  },
  {
    column: "Marca",
  },
  {
    column: "Endereço",
  },
  {
    column: "Município",
  },
  {
    column: "Última Coleta",
  },
  {
    column: "Média",
  },
  {
    column: "Prioridade",
  },
  {
    column: "QTDE ÓLEO",
  },
  {
    column: "Valor R$",
  },
  {
    column: "1 DETERG",
  },
  {
    column: "2 DESINF",
  },
  {
    column: "3 AGUAS",
  },
  {
    column: "4 SPEDRA",
  },
  {
    column: "7 AMACIA",
  },
  {
    column: "11 DT 500ml",
  },
  {
    column: "12 L.ALUM",
  },
  {
    column: "13 A.S. 1L",
  },
];

const diasDaSemana = {
  1: "Domingo",
  2: "Segunda-Feira",
  3: "Terça-Feira",
  4: "Quarta-Feira",
  5: "Quinta-Feira",
  6: "Sexta-Feira",
  7: "Sábado",
};

function RelatorioFreguesia({ freguesia, dia, table }) {
  return (
    <div className={styles.container_relatorio}>
      <header id="cabecalho-relatorio">
        <div style={{ textAlign: "center", marginBottom: "16px" }}>
          <strong>
            Freguesia {freguesia} {diasDaSemana[dia]}
          </strong>
          <label> DATA __/__/ {new Date().getFullYear()}</label>
        </div>
        <div className={styles.container_row}>
          <label>MOTORISTA _____________________________________</label>
          <label>PLACA ____________________</label>
          <label>AJUDANTE _______________________________</label>
        </div>
        <div className={styles.container_row}>
          <label>LEVOU R$ __________</label>
          <label>DEVOLVEU R$ __________</label>
          <label>SAIDA ___________________________</label>
          <label>CHEGADA ___________________________</label>
        </div>
        <div className={styles.container_row}>
            <label>Qtde Prod.</label>
            <label>Det:______</label>
            <label>Desinf:______</label>
            <label>A.S.5L:______</label>
            <label>Sabão:______</label>
            <label>Amac:______</label>
            <label>Dt 500ml:______</label>
            <label>L.A:______</label>
            <label>A.S.1L:______</label>
        </div>
        <ul className={styles.container_row} style={{ flexWrap: "wrap" }}>
          <strong>PAGTO: </strong>
          {formasDePagamento.map((pag, index) => (
            <li key={index}>{pag.tipo}</li>
          ))}
        </ul>
      </header>
      {table.length ? (
        <Table columns={columns}>
          {table.map((values) => (
            <tr key={values?.id_local}>
              <td>{values?.Codigo}</td>
              <td style={{ textAlign: "left" }}>{values?.Marca}</td>
              <td style={{ textAlign: "left" }}>{values?.Logradouro}</td>
              <td style={{ textAlign: "left" }}>{values?.Bairro}</td>
              <td>{values?.DataEntrada}</td>
              <td>{values?.Media}</td>
              <td>{values?.Prioridade}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          ))}
        </Table>
      ) : null}
    </div>
  );
}

export default RelatorioFreguesia;
